import { render, staticRenderFns } from "./Facebook.vue?vue&type=template&id=085ca193&scoped=true"
import script from "./Facebook.vue?vue&type=script&lang=js"
export * from "./Facebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085ca193",
  null
  
)

export default component.exports